import ArticleCardMinified from 'app/features/Blog/components/ArticleCardMinified'
import { generateArticleLink } from 'app/utils/helpers/blog.helpers'

import ColumnContainer from './ColumnContainer'

interface RightSideArticlesProps {
  articles: BlogArticleModel[]
  loading?: boolean
  isMobile?: boolean
}

const RightSideArticles: RFC<RightSideArticlesProps> = ({
  articles,
  loading,
  isMobile
}) => {
  return (
    <ColumnContainer
      sx={{
        flexGrow: 2,
        rowGap: 2,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {articles.map((article, idx, arr) => {
        const isLastElement = idx === arr.length - 1
        const link = generateArticleLink({
          slug: article.slug,
          categorySlug: article.blog_category?.slug
        })

        return (
          <ArticleCardMinified
            loading={loading}
            key={article.id}
            link={link}
            title={article.title}
            image={article.title_image_url}
            createdAt={article.created_at}
            imageAltText={article?.title_image?.alt_text}
            isMobile={isMobile}
            index={idx}
            sx={{
              ...(!isLastElement && {
                borderBottomColor: 'border.main',
                borderBottomStyle: 'solid',
                borderBottomWidth: '1px',
                pb: 2
              })
            }}
          />
        )
      })}
    </ColumnContainer>
  )
}

export default RightSideArticles
